import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { MaterialModule } from './material.module';
import { SliderModule } from 'primeng/slider';
import { RootComponent } from './root.component';

import { Panel } from '../components/panel/panel.component';
import { MultiPanel } from '../components/multi-panel/multi-panel.component';
import { BackgroundColorDirective } from './background.directive';
import { ListErrorsComponent } from './list-errors/list-errors.component';
import { InnerLoader } from './inner-loader/inner-loader.component';
import { NotAvailableComponent } from '../components/not-available/not-available.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafLetMapsComponent } from '../components/leaflet-maps/leaflet-maps.component';
import { LeafletMarkerClusterModule } from '@asymmetrik/ngx-leaflet-markercluster';
import { DropSelectComponent } from '../components/drop-select/drop-select.component';
import { PagePanel } from '../components/page-panel/page-panel.component';
import { CompetitorsTableComponent } from '../components/main-table/compotitors-table/competitors-table.component';
import { DeleteDialogComponent } from '../domain/shops-wrapper/shops/components/delete-dialog/delete-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { DisableControlDirective } from './disable.directive';
import {
    InfoDialogComponent,
    AlertsInfoDialogComponent,
} from './info-dialog/info-dialog.component';
import { MainTableComponent } from '../components/main-table/main-table.component';
import { StandartTableComponent } from '../components/main-table/normal-table/normal-table.component';
import { InnerTableTableComponent } from '../components/main-table/inner-table/inner-table.component';
import { ImportDialogComponent } from '../components/import-dialog/import-dialog.component';
import { TabsNavbarComponent } from '../components/tabs-navbar/tabs-navbar.component';
import { CustomTablePanelComponent } from '../components/custom-panel/table-panel/table-panel.component';
import { CustomPanelComponent } from '../components/custom-panel/custom-panel.component';
// tslint:disable-next-line: max-line-length
import { NotEmptyPipe } from './pipes/not-empty.pipe';
import { ButtonSpinnerDirective } from './button-spinner.component';
import { DeleteModalComponent } from '../components/delete-modal/delete-modal.component';
import { AbnormalTableComponent } from '../components/main-table/abnormal-table/abnormal-table.component';
import { LimitToDirective } from './limit-input.directive';
import { TableCellTextPipe } from './pipes/table-cell.pipe';
import { HideUnauthorizedDirective } from './hide-unauthorized.directive';
import { TableHelperService } from './tables/table-helper.service';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { PromotionItemsTableComponent } from 'app/components/main-table/promotion-items-table/promotion-items-table.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ChartsModule } from 'ng2-charts';
import { InputTextModule } from 'primeng/inputtext';
import {TableComponent} from '../components/new-table/table/table.component';
import {ReferencesDialogComponent} from './references-dialog/references-dialog.component';
import {LocalTableComponent} from '../components/new-table/local-table/local-table.component';
import {NewSelectTableComponent} from '../components/new-table/select-table/select-table.component';
import {NewUnselectTableComponent} from '../components/new-table/unselect-table/unselect-table.component';
import {SelectTableComponent} from '../components/main-table/select-table/select-table.component';
import {SelectByColumnComponent} from '../components/new-table/select-by-column/select-by-column.component';
import {DialogDeletePrices} from '../surroundings/prices-competitors/prices-comp-browser/prices-comp-browser.component';
import {SelectTreeComponent} from '../components/new-table/select-tree/select-tree.component';
import {TreeModule} from 'primeng/tree';
import {SelectButtonModule} from 'primeng/selectbutton';
import {TooltipModule} from 'primeng/tooltip';
import {CreatePriceContractDialogComponent} from '../components/create-price-contract-dialog/create-price-contract-dialog.component';
import {DeletePriceContractDialogComponent} from '../components/delete-price-contract-dialog/delete-price-contract-dialog.component';
import {UpdatePriceContractDialogComponent} from '../components/update-price-contract-dialog/update-price-contract-dialog.component';
import {CalendarModule} from 'primeng/calendar';

import {DetailsWrapperComponent} from '../components/details-wrapper/details-wrapper.component';
import {DetailsPropWrapperComponent} from '../components/details-prop-wrapper/details-prop-wrapper.component';
import {ButtonComponent} from '../components/button/button.component';
import {CheckboxModule} from 'primeng/checkbox';
import {NewConfirmDialogComponent} from './new-confirm-dialog/new-confirm-dialog.component';
import { PbiReportComponent } from 'app/components/pbi-report/pbi-report.component';

const modules = [
    CommonModule,
    ChartsModule,
    DropdownModule,
    MultiSelectModule,
    FlexLayoutModule,
    FormsModule,
    HttpClientModule,
    LeafletMarkerClusterModule,
    LeafletModule,
    MaterialModule,
    ReactiveFormsModule,
    RouterModule,
    SliderModule,
    TableModule,
    InputTextModule,
    TreeModule,
    SelectButtonModule,
    TooltipModule,
    CalendarModule,
    CheckboxModule
];

const declare = [
    RootComponent,
    Panel,
    MultiPanel,
    BackgroundColorDirective,
    ListErrorsComponent,
    InnerLoader,
    NotAvailableComponent,
    LeafLetMapsComponent,
    DropSelectComponent,
    PagePanel,
    CompetitorsTableComponent,
    DeleteDialogComponent,
    ConfirmDialogComponent,
    InfoDialogComponent,
    DisableControlDirective,
    MainTableComponent,
    StandartTableComponent,
    InnerTableTableComponent,
    PromotionItemsTableComponent,
    ImportDialogComponent,
    CreatePriceContractDialogComponent,
    DeletePriceContractDialogComponent,
    UpdatePriceContractDialogComponent,
    DialogDeletePrices,
    TabsNavbarComponent,
    CustomPanelComponent,
    CustomTablePanelComponent,
    NotEmptyPipe,
    ButtonSpinnerDirective,
    DeleteModalComponent,
    AbnormalTableComponent,
    LimitToDirective,
    TableCellTextPipe,
    HideUnauthorizedDirective,
    AlertsInfoDialogComponent,
    SafeHtmlPipe,
    TableComponent,
    LocalTableComponent,
    ReferencesDialogComponent,
    NewSelectTableComponent,
    NewUnselectTableComponent,
    SelectTableComponent,
    SelectByColumnComponent,
    SelectTreeComponent,
    DetailsWrapperComponent,
    DetailsPropWrapperComponent,
    ButtonComponent,
    NewConfirmDialogComponent,
    PbiReportComponent
];

@NgModule({
    declarations: [...declare],
    imports: [...modules],
    exports: [...modules, ...declare],
    providers: [TableHelperService],
    bootstrap: [LeafLetMapsComponent],
    entryComponents: [
        DeleteDialogComponent,
        ConfirmDialogComponent,
        InfoDialogComponent,
        ImportDialogComponent,
        CreatePriceContractDialogComponent,
        DeletePriceContractDialogComponent,
        CreatePriceContractDialogComponent,
        DialogDeletePrices,
        DeleteModalComponent,
        AlertsInfoDialogComponent,
    ],
})
export class SharedModule {}
